import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Inspection, FormMode, ShownModules, UserPermissions } from "./models/InspectionModel";
import { HistoryDto } from "./models/HistoryModel";

export default class ExampleVuexModule extends AbacoVuexModule {
  @State() exampleNavBarFilterOpen!: boolean;
  @State({ default: null }) inspection!: Inspection | null;
  @State({ default: false }) openInspectionEditor!: boolean;
  @State({ default: FormMode.LIST }) formMode!: FormMode;
  @State({ default: null }) clickedCoords!: { latitude: number; longitude: number } | null;
  @State({ default: false }) isMapClickable!: boolean;
  @State({ default: null }) shownModules!: ShownModules | null;
  @State({ default: null }) userPermissions!: UserPermissions | null;
  // Check MandatoryModulesCompiled
  @State({ default: false }) haveMandatoryModulesCompiled!: boolean;
  // !Warning: The following state will create a lot of side effects
  @State({ default: { isVisible: false, isLoading: false } }) history!: HistoryDto;
}
